import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingService } from '../../core/services/loading.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader',
   standalone: true,
     imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  show: Observable<boolean> | undefined;

  constructor(private loading: LoadingService) { }

  ngOnInit() {
    this.show = this.loading.loading;
  }

}
